<template>
  <div class="position-relative">
    <login-modal :mode="'float'" />
    <div class="mobile-hide">
      <VueSlickCarousel v-if="carousel.length !== 0" class="slider single-item index-slick" v-bind="slick_setting" :arrows="false">
        <a v-for="(item, key) in carousel" :key="key" class="d-block" :href="item.link" :target="item.open_type">
          <img :src="item.image">
        </a>
      </VueSlickCarousel>
    </div>
    <div class="pc-hide">
      <VueSlickCarousel v-if="carousel.length !== 0" class="slider single-item index-slick" v-bind="slick_setting" :arrows="false">
        <a v-for="(item, key) in carousel" :key="key" class="d-block" :href="item.pc_link" :target="item.pc_open_type">
          <img :src="item.pc_image">
        </a>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import { getCarousel } from '@/api/brand'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import loginModal from '@/components/modal/loginModal'
import { detectMob } from '@/utils/tool'

export default {
  components: {
    VueSlickCarousel,
    loginModal
  },
  data() {
    return {
      carousel: [],
      slick_setting: {
        pauseOnHover: true,
        adaptiveHeight: false,
        dots: true,
        infinite: true,
        draggable: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        initialSlide: 0,
        dotsClass: 'slick-dots'
      }
    }
  },
  mounted() {
    if (this.$store.getters.brand.theme === 'theme2' && detectMob()) {
      this.slick_setting.dots = false
    }
    getCarousel().then(response => {
      this.carousel = response.data.data
    })
  },
  methods: {
    isMobile() {
      return detectMob()
    }
  }
}
</script>

<style>
@media only screen and (min-width: 992px) {
  .index-slick .slick-slide a {
    height: 410px !important;
  }
}
/* @media only screen and (min-width: 767px) {
  .main-carousel, .main-carousel img {
    width: 100%;
    height: 585px;
    object-fit: cover;
    object-position: bottom;
  }
}
@media only screen and (max-width: 766px) {
  .index_slider_area .slick-slide {
    background-position: center;
    height: 100%;
  }
  .main-carousel .slick-list,
  .main-carousel, .main-carousel img {
    height: auto;
    margin-bottom: 10px;
  }
}
.index_slider_area .index_slider_dots{
  bottom: 20px;
} */
.index-slick .slick-dots li button::before {
  opacity: 1;
}
</style>
